import React from 'react';
import PropTypes from '../../util/PropTypes';

const propTypes = {
    className: PropTypes.string,
    variant: PropTypes.oneOf(['blue', 'white', 'black']),
};

const defaultProps = {
    className: null,
    variant: 'blue',
};

const colors = {
    blue: '#0092dd',
    white: '#fff',
    black: '#222',
};

const BrainbitsLogo = ({ className, variant }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165 29">
        <path
            d="M102.86 1.2v8.65a10.45 10.45 0 11-.26 15.52 3.74 3.74 0 01-3.09 2.77l-.1.02-.15.02V1.19h3.6zm-99.05 0v8.65a10.45 10.45 0 11-.26 15.52 3.74 3.74 0 01-3.09 2.77l-.1.02-.15.02V1.19h3.6zm161.15 6.23v2.92h-7.32c-2 .02-2.55.49-2.55.49a2.9 2.9 0 00-1.3 2.22v.2c0 1.06.57 2 1.43 2.5 0 0 .5.24.93.3a10.67 10.67 0 001.96.02l1.82-.02c2.73 0 4.96 2.59 5.07 5.82v.24c0 3.34-2.27 6.05-5.07 6.05h-10.38c.9-2.8 3.15-2.96 3.4-2.97h5.75a2.99 2.99 0 002.92-2.88v-.18a3 3 0 00-2.81-3.07h-1.44a7.65 7.65 0 01-5.24-1.74 4.94 4.94 0 01-1.65-3.67v-.28a5.6 5.6 0 014.36-5.59s1.3-.36 5.74-.36h4.38zm-40.4-.12l.15.03c.97.12 2.87.73 3.36 3.49 0 0 .09.63.09 1.19v16.13l-3.6.03V7.3zm-41.02-.13l.34.01c1.51.1 5.64.72 7.91 4.62 0 0 1.2 2.34 1.37 4.7v.07c.1.77.17 1.64.18 2.39l.02 4.79.01 4.2v.21l-.15-.02c-.97-.12-2.88-.72-3.38-3.48 0 0-.08-.63-.08-1.19v-.56l-.01-2.59v-1.42c.08-1.62-.35-3.38-.35-3.38a6.27 6.27 0 00-5.63-4.1h-.47a6.27 6.27 0 00-5.63 4.1v.04c-.06.24-.42 1.85-.35 3.34v4.57c0 .57-.09 1.2-.09 1.2-.5 2.75-2.4 3.35-3.37 3.47l-.16.03v-.22l.02-4.2.02-4.8c0-.74.08-1.6.17-2.38v-.07c.17-2.36 1.37-4.7 1.37-4.7 2.28-3.9 6.4-4.52 7.91-4.62l.34-.02h.01zm-19.42.13l.16.03c.97.12 2.87.73 3.36 3.5 0 0 .07.52.08 1.05V28.15l-3.6.03V7.3zm-9.74-.07h3.6v20.94l-.16-.03a3.75 3.75 0 01-3.2-2.78 10.45 10.45 0 11-.25-15.51V7.23zm79.8-6.3l.16.02c.97.13 2.87.74 3.36 3.5 0 0 .07.53.08 1.06v4.12h6.43v3.05h-6.43v.8c0 1.39.02 3.13.06 4.02.04.69.32 2.18.32 2.18.37 1.52 1.35 3.77 4.02 4.41 0 0 1.77.57 4.26.57v3.51l-2.45-.02c-1.51-.04-9.55-.7-9.8-11V.94zM28.25 9.63s3.95-3.58 9.9-1.77l-.37.42-2.2 2.6-.02.01-.13-.02c-2.77-.25-4.83 1.33-4.83 1.33a6 6 0 00-2.36 3.66s-.3 1.48-.33 2.17l-.04 1.39v.22l.01 3.47v.36c0 .56-.08 1.19-.08 1.19-.5 2.76-2.4 3.37-3.36 3.5l-.16.02V18.55c.12-4.74 1.93-7.42 3.97-8.93zm81.49 1.24a6.86 6.86 0 100 13.72 6.86 6.86 0 000-13.72zm-99.06 0a6.86 6.86 0 10.01 13.72 6.86 6.86 0 000-13.72zm36.84 0a6.86 6.86 0 100 13.72 6.86 6.86 0 000-13.72zM126.22.07a2.2 2.2 0 110 4.39 2.2 2.2 0 010-4.39zM65.8 0a2.2 2.2 0 110 4.38 2.2 2.2 0 010-4.38z"
            fill={colors[variant]}
            fillRule="nonzero"
        />
    </svg>
);

BrainbitsLogo.propTypes = propTypes;
BrainbitsLogo.defaultProps = defaultProps;

export default BrainbitsLogo;
